import React from 'react'
import './policy.css'
import useDocumentTitle from '../useDocumentTitle.js';

function Privacy() {
  window.scrollTo(0, 0);
  useDocumentTitle("Privacy Policy")

  return (
    <div className='policy'>
      <div>
        <h1>Privacy Policy</h1>
        <p>Last updated: 10 January 2026</p>
      </div>

      <p>
        Vrajpath Itech LLP ("we", "our", "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your information when you use our software services, mobile applications, and digital platforms.
      </p>

      <h2>Information We Collect</h2>

      <h3>1. Personal Information</h3>
      <ul>
        <li>Name</li>
        <li>Email address</li>
        <li>Phone number</li>
        <li>Business or company details</li>
      </ul>

      <h3>2. Usage Data</h3>
      <p>
        We automatically collect information such as IP address, device type, browser, pages visited, and time spent on our platform.
      </p>

      <h3>3. Transaction Data</h3>
      <p>
        Payment details and transaction history (processed securely via third-party payment gateways).
      </p>

      <h2>How We Use Your Information</h2>
      <ul>
        <li>To provide and maintain our services</li>
        <li>To manage user accounts</li>
        <li>To process transactions</li>
        <li>To improve platform performance and user experience</li>
        <li>To send updates, notifications, and support messages</li>
      </ul>

      <h2>Data Sharing</h2>
      <p>We may share your data with:</p>
      <ul>
        <li>Payment gateway providers</li>
        <li>Analytics and cloud service providers</li>
        <li>Legal authorities when required by law</li>
      </ul>

      <p>We do <strong>not sell your personal data</strong>.</p>

      <h2>Data Security</h2>
      <p>
        We use industry-standard security practices including encryption, access control, and secure servers to protect your data.
      </p>

      <h2>Data Retention</h2>
      <p>
        We retain your data only as long as necessary for service delivery, legal compliance, and dispute resolution.
      </p>

      <h2>Your Rights</h2>
      <ul>
        <li>Access your personal data</li>
        <li>Update or correct your information</li>
        <li>Request deletion of your data</li>
      </ul>

      <h2>Cookies & Tracking</h2>
      <p>
        We use cookies and similar technologies to improve user experience and analyze platform usage.
      </p>

      <h2>Third-Party Services</h2>
      <p>
        Our platform may include integrations with third-party services. We are not responsible for their privacy practices.
      </p>

      <h2>Children’s Privacy</h2>
      <p>
        Our services are not intended for individuals under the age of 18.
      </p>

      <h2>Changes to This Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. Continued use of the platform implies acceptance of updated policies.
      </p>

      <h2>Contact Us</h2>
      <ul>
        <li>Email: support@vrajpath.com</li>
        <li>Website: <a href="https://www.vrajpath.com" target="_blank" rel="noopener noreferrer">https://www.vrajpath.com</a></li>
        <li>Phone: +91-9818527999</li>
      </ul>
    </div>
  )
}

export default Privacy